<template>
  <div>
    <div
      v-if="!isDeviceLinked"
      class="device device_unlinked-wrap"
      :class="{ device_expanded: isDropdownShown }"
    >
      <div class="device_unlinked-bar">
        <router-link class="device_unlinked-cta" :to="linkRoute">
          <img class="device__icon" src="@/assets/icon-device.svg" />
          <span class="device__link-text">{{ $t("INSTALL_BRAND") }}</span>
        </router-link>
        <button type="button" class="device_unlinked-menu" @click="toggleDropdown">
          <img class="device__d-icon device__d-icon_desktop" src="@/assets/icon-dropdown-white.svg" />
          <img class="device__d-icon device__d-icon_mobile" src="@/assets/icon-dropdown-black.svg" />
        </button>
      </div>
      <ul class="dropdown" v-show="isDropdownShown" @click.stop>
        <li class="dropdown__item" v-for="(item, index) in unlinkedMenuItems" :key="index">
          <router-link class="dropdown__link" :to="item.link" @click.native="closeDropdown">
            {{ item.title }}
          </router-link>
        </li>
      </ul>
    </div>
    <button v-else class="device device_linked" :class="{ device_expanded: isDropdownShown }" @click="toggleDropdown">
      <img class="device__icon" src="@/assets/icon-device.svg" />
      <span class="device__selected">{{ $t("SELECTED_DEVICE") }}</span>
      <span class="device__text">{{ currentDevice.model }} <span v-if="currentDevice.name">{{ currentDevice.name
          }}</span></span>
      <span class="device__pro" v-if="currentDevice.plus">PLUS</span>
      <span class="device__premium" v-if="currentDevice.premium">PREMIUM</span>
      <img class="device__d-icon device__d-icon_desktop" src="@/assets/icon-dropdown-white.svg" />
      <img class="device__d-icon device__d-icon_mobile" src="@/assets/icon-dropdown-black.svg" />
      <span class="device__desc">
        {{ currentDevice.ios }},
        {{ config.signing_with }}
        <template v-if="!hasPlus && !hasPremium && config && config.free_signs_left != undefined">
          {{ $t('N_FREE_SIGNS_LEFT', { n: config.free_signs_left }) }}
        </template>
      </span>

      <ul class="dropdown" v-show="isDropdownShown">
        <li class="dropdown__item" v-for="(item, index) in menuItems" :key="index">
          <a v-if="item.external" class="dropdown__link" :href="item.link" :target="item.target">
            {{ item.title }}
          </a>
          <router-link v-else class="dropdown__link" :to="item.link">
            {{ item.title }}
          </router-link>
        </li>
      </ul>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isItselfLinkable from '@/utils/isItselfLinkable';
import getMainMenuItems from '@/utils/MainMenu';

export default {
  data() {
    return {
      isDropdownShown: false,
      menuItems: [],
    };
  },
  computed: {
    ...mapGetters(['hasPlus', 'hasPremium', 'config']),
    linkRoute() {
      return isItselfLinkable() ? '/link' : '/link-qr';
    },
    unlinkedMenuItems() {
      return [
        { title: this.$t('NEWS'), link: '/news' },
        { title: this.$t('HOW_TO_SIDELOAD'), link: '/my/faq' },
      ];
    },
    isDeviceLinked() {
      return this.$store.getters.isDeviceLinked;
    },
    currentDevice() {
      const { devices } = this.$store.getters;
      if (devices.length) {
        return devices.find(device => device.lt === this.$store.getters.lt);
      }

      const { config } = this.$store.getters;
      if (Object.keys(config).length) {
        return {
          model: config.nice_idevice_model,
          ios: config.ios_version,
          signing_with: config.signing_with,
          app_installation_method: config.app_installation_method,
        };
      }

      return null;
    },
  },
  methods: {
    closeDropdown() {
      this.isDropdownShown = false;
    },
    toggleDropdown() {
      this.isDropdownShown = !this.isDropdownShown;
    },
    handleDropdown(e) {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('device'))) {
        return;
      }
      this.isDropdownShown = false;
    },
  },
  created() {
    this.menuItems = getMainMenuItems();
  },
  mounted() {
    document.body.addEventListener('click', this.handleDropdown);
  },
  destroyed() {
    document.body.removeEventListener('click', this.handleDropdown);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.device {
  display: flex;
  font-size: 14px;
  align-items: center;
  background-color: $primary;
  color: #fff;
  padding: 10px;
  font-weight: 500;
  background: $primary;
  box-shadow: 0 2px 4px 0 var(--shadow-color);
  border-radius: 2px;
  position: relative;
  white-space: nowrap;
  @include transition;

  &:hover {
    box-shadow: 0 2px 8px 0 var(--shadow-clor);

    @include notebook {
      box-shadow: none;
    }
  }

  @include notebook {
    height: 41px;
    box-shadow: none;
    transition: none;

    &:not(&_linked) {
      background: none;
      color: $primary;
      border: 1px solid $primary;
    }
  }

  &_unlinked-wrap {
    padding: 0;
    overflow: visible;

    .device_unlinked-bar {
      display: flex;
      align-items: stretch;
      width: 100%;
      min-width: 0;
    }

    .device_unlinked-cta {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      padding: 10px 4px 10px 10px;
      color: inherit;
      text-decoration: none;

      @include notebook {
        padding: 10px 8px 10px 10px;
      }
    }

    .device_unlinked-menu {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px 0 4px;
      margin: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      color: inherit;
      font: inherit;
      border-left: 1px solid rgba(255, 255, 255, 0.35);

      @include notebook {
        border-left-color: var(--tertiary-accent);
      }
    }

    .device__d-icon {
      position: static;
      right: auto;
      margin: 0;
    }

    @include notebook {
      &:not(.device_expanded) {
        align-items: stretch;
      }
    }
  }

  &_linked {
    background-image: $header-device-button-gradient;
    border: 1px solid $dark-primary;
    max-width: 170px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 22px;

    @include notebook {
      background: var(--tertiary-bg);
      border: none;
      max-width: 300px;
      color: var(--text-primary);
      padding-top: 17px;
      padding-bottom: 3px;
      width: 100%;
      min-width: 110px;
    }
  }

  &_expanded {
    @include notebook {
      position: absolute;
      z-index: 9;
      height: auto;
      top: 0;
      background: var(--bg);
      border: 1px solid rgba(0, 0, 0, 0.15);
      box-shadow: 0 6px 25px rgba(0, 0, 0, 0.35);
      border-radius: 8px;
      width: auto;
      flex-direction: column;
      align-items: flex-start;
      padding: 10px 10px 0;
      overflow: hidden;
      max-width: calc(100vw - 85px);
      width: 206px;
    }
  }

  &__link-text {
    flex: 1 0 auto;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon {
    position: relative;
    top: 1px;
    margin-right: 5px;

    @include notebook {
      display: none;
    }
  }

  &_expanded &__pro {
    @include notebook {
      margin-left: 0;
      position: absolute;
      left: 95px;
      top: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 10px;

      &+.device__pro {
        left: 135px;
      }
    }
  }

  &__pro {
    display: none;

    @include notebook {
      display: block;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      background: $primary;
      border-radius: 1.5px;
      padding: 3px 5px;
      color: #fff;
      margin-left: 6px;
    }
  }

  &__premium {
    display: none;

    @include notebook {
      display: block;
      font-size: 11px;
      font-weight: 700;
      background: $primary;
      border-radius: 1.5px;
      padding: 3px 5px;
      color: #fff;
      margin-left: 6px;
    }
  }

  &_expanded &__premium {
    @include notebook {
      margin-left: 0;
      position: absolute;
      left: 135px;
      top: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 10px;
    }
  }

  &_expanded &__d-icon {
    @include notebook {
      display: none;
    }
  }

  &__d-icon {
    position: relative;
    right: -12px;

    &_desktop {
      @include notebook {
        display: none;
      }
    }

    &_mobile {
      display: none;

      @include notebook {
        display: block;
        position: absolute;
        right: 7px;
        top: 0;
        bottom: 0;
        margin: auto;
        filter: var(--img-filter);
      }
    }
  }

  &_expanded &__selected {
    @include notebook {
      background: var(--tertiary-accent);
      border-radius: 2px;
      padding: 2px;
      position: static;
      order: 0;
    }
  }

  &__selected {
    display: none;

    @include notebook {
      display: block;
      text-align: left;
      color: var(--text-secondary);
      font-size: 10px;
      font-weight: 400;
      position: absolute;
      top: 5px;
      left: 10px;
    }
  }

  &_expanded &__text {
    @include notebook {
      margin: 4px 0;
      order: 2;
      white-space: normal;
    }
  }

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @include notebook {
      text-align: left;
    }
  }

  &_expanded &__desc {
    @include notebook {
      display: block;
      position: static;
      order: 2;
      white-space: normal;
      text-align: left;
    }
  }

  &__desc {
    position: absolute;
    right: 0;
    color: var(--text-primary);
    font-size: 12px;
    white-space: nowrap;
    bottom: -20px;
    pointer-events: none;

    @include notebook {
      display: none;
    }
  }

  &_expanded .dropdown {
    @include notebook {
      width: calc(100% + 20px);
      margin-top: 10px;
      position: relative;
      left: -10px;
      top: 0;
      right: 0;
      order: 4;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

      &__link {
        color: var(--text-primary);
        padding: 5px 10px;
        white-space: normal;
      }

      &__item {
        &:first-child:after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          height: 1px;
          background-color: var(--tertiary-accent);
        }

        &:after,
        &:before {
          left: 0 !important;
          right: 0 !important;
        }
      }
    }
  }
}

.dropdown {
  position: absolute;
  top: 35px;
  right: -1px;
  background: var(--bg);
  border: 1px solid var(--light-primary);
  box-shadow: 0 0 15px 0 var(--shadow-color), 0 4px 10px 0 var(--shadow-color);
  border-radius: 2px;
  z-index: 9;
  text-align: left;

  @include notebook {
    left: 0;
    right: 0;
    border: none;
    box-shadow: none;
    border-bottom: 1px solid var(--tertiary-accent);
    background-color: var(--bg);
  }

  &__item {
    position: relative;

    @include notebook {
      &:hover {
        background-color: var(--lighter-primary);
      }
    }

    &_desktop {
      @include notebook {
        display: none;
      }
    }

    &_mobile {
      display: none;

      @include notebook {
        display: block;
      }
    }

    &:not(:last-child):before {
      content: "";
      display: block;
      position: absolute;
      left: 5px;
      right: 5px;
      bottom: 0;
      height: 1px;
      background-color: var(--tertiary-accent);

      @include notebook {
        left: 0;
        right: 0;
        background-color: var(--tertiary-accent);
      }
    }
  }

  &__link {
    display: flex;
    align-items: center;
    color: $primary;
    font-size: 12px;
    padding: 9px 16px;
    white-space: nowrap;
    @include transition;

    &:hover {
      background-color: var(--lighter-primary);
    }

    @include notebook {
      border-top: 1px solid var(--tertiary-accent);
    }

    &_bold {
      justify-content: center;
      color: var(--text-tertiary);
      font-weight: 600;
    }
  }

  &__icon {
    margin-left: 3px;
  }
}
</style>
